import { render, staticRenderFns } from "./item.text-block.vue?vue&type=template&id=e5ca72be&scoped=true&"
import script from "./item.text-block.vue?vue&type=script&lang=js&"
export * from "./item.text-block.vue?vue&type=script&lang=js&"
import style0 from "./item.text-block.vue?vue&type=style&index=0&id=e5ca72be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ca72be",
  null
  
)

export default component.exports